// extracted by mini-css-extract-plugin
export default {"root":"AddProfileMenu_root__e4nQd","top":"AddProfileMenu_top__1uDVN","middle":"AddProfileMenu_middle__eXFm9","bottom":"AddProfileMenu_bottom__FkzbE"};